import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import Banner1 from '../assets/images/gainbanner1.jpg';
import Banner2 from '../assets/images/gainbanner2.jpg';
import Banner3 from '../assets/images/gainbanner3.jpg';
import MobileBanner1 from '../assets/images/mobile1.jpg';
import MobileBanner2 from '../assets/images/mobile2.jpg';
import MobileBanner3 from '../assets/images/mobile3.jpg';
// import Banner2 from '../assets/images/banner2.jpg';
// import Banner3 from '../assets/images/banner3.jpg';

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const slides = [
    {
      id: 1,
      image: Banner1,
      mobileImage: MobileBanner1,
    },
    {
      id: 2,
      image: Banner2,
      mobileImage: MobileBanner2,
    },
    {
      id: 3,
      image: Banner3,
      mobileImage: MobileBanner3,
    }
  ];

  // Otomatik slider geçişi
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Touch event handlers
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };

  return (
    <div className="relative">
      {/* Slider */}
      <div 
        className="relative w-full overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Slider Container */}
        <div 
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="w-full flex-shrink-0 relative">
              {/* Banner Görseli */}
              <div className="relative w-full md:mt-0 mt-12">
                {/* Desktop Banner */}
                <img 
                  src={slide.image} 
                  alt="Banner" 
                  className="hidden md:block w-full h-auto"
                />
                {/* Mobile Banner */}
                <img 
                  src={slide.mobileImage} 
                  alt="Mobile Banner" 
                  className="block md:hidden w-full h-auto"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Controls */}
        <div className="hidden md:flex absolute bottom-6 left-1/2 transform -translate-x-1/2 items-center space-x-4">
          {/* Geri Butonu */}
          <button
            onClick={prevSlide}
            className="bg-[#2E3192] hover:bg-[#CCDC59] text-white hover:text-[#2E3192] p-2 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <Icon icon="mdi:chevron-left" className="w-5 h-5" />
          </button>
          
          {/* Dots Indicator */}
          <div className="flex space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentSlide 
                    ? 'bg-[#CCDC59] scale-125' 
                    : 'bg-[#2E3192] hover:bg-[#CCDC59]'
                }`}
              />
            ))}
          </div>
          
          {/* İleri Butonu */}
          <button
            onClick={nextSlide}
            className="bg-[#2E3192] hover:bg-[#CCDC59] text-white hover:text-[#2E3192] p-2 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <Icon icon="mdi:chevron-right" className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
